import { Component } from '@angular/core';
import { BaseErrorPageComponent } from '../base-error-page.component';

@Component({
    selector: 'app-not-found-page',
    templateUrl: './not-found-page.component.html',
    styleUrl: '../../../shared-styles/error-page.scss'
})
export class NotFoundPageComponent extends BaseErrorPageComponent {
}
